<template>
	<div class="settings">
		<b-container class="bv-example-row">
			<b-card header-tag="header" footer-tag="footer">
				<div slot="header" class="top-card d-flex align-items-center justify-content-between">
					<span>
						<h5>{{ $t('sidebar.pos.settings') }}</h5>
					</span>
					<b-button v-if="$can('create', 'cashbox')" variant="outline-info"
						@click.prevent="openCashboxModal({})">
						<i class="fa fa-plus"></i> &nbsp;
						<span>{{ $t('client.addClient') }}</span>
					</b-button>
				</div>
				<!--				<b-row class="frame-setting">-->
				<!--					<b-col col lg="4" md="6" sm="12">-->
				<!--						<div class="cashbox">-->
				<!--							<h4>{{ $t('kassa.nomer') }}:</h4>-->
				<!--							<span class="cashboxnumber">{{ cashboxName }}</span>-->
				<!--						</div>-->
				<!--					</b-col>-->
				<!--					<b-col col lg="4" md="6" sm="12">-->
				<!--						<b-form-select v-model="cashboxId"-->
				<!--									   :plain="false"-->
				<!--									   :options="cashboxList"-->
				<!--									   size="sm"-->
				<!--									   label-for="Position"-->
				<!--									   :required="true"-->
				<!--									   :text-field="'name'"-->
				<!--									   :value-field="'id'"-->
				<!--						>-->
				<!--							<template slot="first">-->
				<!--								<option :value="null" disabled>-->
				<!--									&#45;&#45;{{ $t('posSettings.selectMessage') }}&#45;&#45;-->
				<!--								</option>-->
				<!--							</template>-->
				<!--						</b-form-select>-->
				<!--						<div class="btn-frame">-->
				<!--							<b-button variant="outline-info" @click.prevent="saveCashboxNumber">-->
				<!--								<i class="fa fa-save"></i> &nbsp;-->
				<!--								<span>{{ $t('actions.save') }}</span>-->
				<!--							</b-button>-->
				<!--						</div>-->
				<!--					</b-col>-->
				<!--					<b-col v-if="show">-->
				<!--						<b-alert variant="success" class="success-save" :show="show">-->
				<!--							{{ $t('posSettings.successMessage') }}-->
				<!--						</b-alert>-->
				<!--					</b-col>-->

				<!--					<b-col v-if="errorShow">-->
				<!--						<b-alert variant="danger" class="success-save" :show="errorShow">-->
				<!--							{{ $t('posSettings.errorMessage') }}-->
				<!--						</b-alert>-->
				<!--					</b-col>-->
				<!--				</b-row>-->

				<!-- SELECT DEPARTMENT FOR SEARCHING CASHBOX_LIST -->
				<b-row class="mt-4">
					<b-col cols sm="8" md="6">
						<b-form-group label-cols="3" label-cols-lg="2" label-size="sm"
							:label="$t('promo-to-product.department')" label-for="refCode" class="required">
							<multiselect v-model="selectedDepForSearch" @input="fetchCashboxList"
								:options="myDepartments" :multiple="false" track-by="id" :show-labels="false"
								:allow-empty="false" label="name" :placeholder="$t('promo-to-product.department')"
								class="multiselect-pricing">
							</multiselect>
						</b-form-group>
					</b-col>
				</b-row>
				<b-table class="generalTableClass" hover="hover" striped="striped" bordered="bordered" small="small"
					fixed="fixed" :items="cashboxList" :fields="computedFields" show-empty>
					<template slot="empty">
						<h4>{{ $t('empty') }}</h4>
					</template>

					<template slot="id" slot-scope="data">
						<strong>{{ data.index + 1 }}</strong>
					</template>

					<template slot="isNew" slot-scope="data">
						<b-badge :class="data.item.isNew ? 'bg-success' : 'bg-danger'">{{ data.item.isNew ? 'Да' :
							'Нет' }}</b-badge>
					</template>

					<template slot="isBar" slot-scope="data">
						<b-badge :class="data.item.isBar ? 'bg-success' : 'bg-danger'">{{ data.item.isBar ? 'Да' : 'Нет'
						}}</b-badge>
					</template>

					<template slot="isSkyShop" slot-scope="data">
						<b-badge :class="data.item.isSkyShop ? 'bg-success' : 'bg-danger'">{{ data.item.isSkyShop ? 'Да'
							:
							'Нет' }}</b-badge>
					</template>

					<template slot="withConsultant" slot-scope="data">
						<b-badge :class="data.item.withConsultant ? 'bg-success' : 'bg-danger'">{{ data.item.withConsultant ? 'Да'
							:
							'Нет' }}</b-badge>
					</template>

					<template slot="actions" slot-scope="data">
						<b-link v-if="$can('update', 'cashbox')" @click.prevent="openCashboxModal(data)">
							<i class="fa fa-pencil editBtn"></i>
						</b-link>
						<b-link @click.prevent="fiscalCreate(data)">
							<i class="fa fa-compass editBtn"></i>
						</b-link>
						<b-link v-if="$can('delete', 'cashbox')" :key="data.item.id + 'delete'"
							@click="onOpen(data.item.id)" :id="'popOverDelete' + data.item.id">
							<i class="fa fa-trash editBtn"></i>
						</b-link>
						<!-- POPOVER TO CONFIRM DELETING THE REFERENCE -->
						<b-popover :key="data.item.id + 'popover'" :target="'popOverDelete' + data.item.id"
							placement="auto" container="myContainer" :ref="'popover' + data.item.id"
							class="refDeleteConfirm">
							<template slot="title">
								<b-button @click="onClose(data.item.id)" class="close" aria-label="Close"
									style="margin-left: 5px">
									<span class="d-inline-block" aria-hidden="true">&times;</span>
								</b-button>
								{{ $t('actions.deletetitle') }}
							</template>

							<div>
								<div class="row mt-1">
									<div class="col-6">
										<b-button variant="outline-danger" size="sm" block
											@click="onClose(data.item.id)">{{
												$t('actions.no') }}
										</b-button>
									</div>
									<div class="col-6">
										<b-button variant="outline-success" size="sm" block
											@click="deleteCashbox(data.item.id)">{{
												$t('actions.yes') }}
										</b-button>
									</div>
								</div>
							</div>
						</b-popover>
					</template>
				</b-table>

				<!--		MODAL FOR ADDING/EDITING CASHBOX		-->
				<b-modal body-class="refModal subReferenceModal" ref="updateRefModal" @shown="focusMyElement"
					hide-footer ok-title="Save"
					:title="modalForAdding ? $t('reference.create.title') : $t('reference.update-title')">
					<div>
						<p v-if="refInputNotFilled" style="color: red;">{{ $t('please-title') }}</p>

						<b-form-group label-cols="4" label-cols-lg="3" label-size="sm"
							:label="$t('reference.create.name')" label-for="refName" class="required">
							<b-form-input :required="true"
								data-errormessage-value-missing="Это поле обязательно для заполнения!" id="childRefName"
								size="sm" v-model="editingItem.name" autofocus="" ref="childRefNameRef"
								:placeholder="$t('reference.create.name')" />
						</b-form-group>

						<b-form-group label-cols="4" label-cols-lg="3" label-size="sm"
							:label="$t('promo-to-product.department')" label-for="refCode" class="required">
							<multiselect v-model="selectedDep" :options="myDepartments" :multiple="false" track-by="id"
								:show-labels="false" :allow-empty="true" label="name"
								:placeholder="$t('promo-to-product.department')" class="multiselect-pricing">
							</multiselect>
						</b-form-group>

						<b-form-group label-cols="4" label-cols-lg="3" label-size="sm" label="IP Address"
							label-for="refValue" class="required">
							<b-form-input id="childRefValue" size="sm" v-model="editingItem.ipAddress"
								placeholder="IP Address" />
						</b-form-group>

						<b-form-group label-cols="4" label-cols-lg="3" label-size="sm" label="Computer IP Address">
							<b-form-input id="childRefValue" size="sm" v-model="editingItem.comIpAddress"
								placeholder="Computer IP Address" />
						</b-form-group>

						<b-form-group label-cols="4" label-cols-lg="3" label-size="sm" label="Новый терминал">
							<b-checkbox v-model="editingItem.isNew" switch></b-checkbox>
						</b-form-group>

						<b-form-group label-cols="4" label-cols-lg="3" label-size="sm" label="Бар">
							<b-checkbox v-model="editingItem.isBar" switch></b-checkbox>
						</b-form-group>

						<b-form-group label-cols="4" label-cols-lg="3" label-size="sm" label="SkyShop">
							<b-checkbox v-model="editingItem.isSkyShop" switch></b-checkbox>
						</b-form-group>

						<b-form-group label-cols="4" label-cols-lg="3" label-size="sm" label="С консультантом">
							<b-checkbox v-model="editingItem.withConsultant" switch></b-checkbox>
						</b-form-group>

						<div class="row mt-3 createRoleModalButtons justify-content-end">
							<div class="col-4">
								<b-button variant="outline-danger" size="sm" block @click="closeCashboxModal">
									{{ $t('actions.cancel') }}
								</b-button>
							</div>
							<div class="col-4">
								<b-button variant="outline-success" size="sm" block @click="addNewCashbox">
									{{ $t('actions.save') }}
								</b-button>
							</div>
						</div>
					</div>
				</b-modal>
			</b-card>
		</b-container>
	</div>
</template>


<script>
import { TokenService } from "@/services/storage.service";
import ApiService from "@/services/api.service";
import { mapActions, mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import FBoxService from "../../../services/fbox.service";

const itemInitial = {
	name: null,
	ipAddress: null,
	comIpAddress: null,
	departmentId: null,
	departmentName: null,
	isBar: false,
	isSkyShop: false,
	withConsultant: false,
	isNew: false,
	status: null
};
export default {
	components: {
		Multiselect
	},
	data() {
		return {
			selectedDepForSearch: null,
			cashboxList: [],
			selectedDep: null,
			refInputNotFilled: false,
			modalForAdding: false,
			editingItem: Object.assign({}, itemInitial),
			fields: [
				{
					key: "id",
					label: "#",
					class: "role_id",
				},
				{
					key: "name",
					label: this.$t("reference.name"),
				},
				{
					key: "ipAddress",
					label: "IP Address",
				},
				{
					key: "comIpAddress",
					label: "Computer IP Address",
				},
				{
					key: "departmentName",
					label: this.$t("incomeFilter.department"),
					sortable: true
				},
				{
					key: "status",
					label: this.$t("sale.status"),
					sortable: true
				},
				{
					key: "isNew",
					label: 'Новый терминал',
					sortable: true
				},
				{
					key: "isBar",

					label: 'Бар',
					sortable: true
				},
				{
					key: "isSkyShop",
					label: 'SkyShop',
					sortable: true
				},
				{
					key: "withConsultant",
					label: 'С консультантом',
					sortable: true
				},
				{
					key: "actions",
					label: this.$t("employees.actions"),
					class: "table_actions",
					sortable: true
				},
			],
			cashboxnumber: '',
			show: false,
			errorShow: false,
			cashboxId: null,
			savedCashboxId: null,
		}
	},
	async created() {
		await this.fetchMyDepartments()

		let userDep = this.myDepartments.find(dep => dep.id == this.userDepId)
		this.selectedDepForSearch = userDep ? Object.assign({}, userDep) : null

		await this.fetchCashboxList()

		//
		this.CashBoxNumber()
		// window.localStorage.removeItem('cashboxnumber')
	},
	computed: {
		...mapGetters('references', [
			'getRefChildren',
		]),
		...mapGetters('departments', [
			'myDepartments'
		]),
		computedFields() {
			return this.fields.filter(f => {
				if (f.key == 'ipAddress') {
					if (this.$can('create', 'cashbox') || this.$can('update', 'cashbox')) {
						return f
					}
				} else {
					return f
				}
			})
		},
		cashboxName() {
			this.getSavedCashboxId()
			if (this.savedCashboxId && this.cashboxList.length)
				return this.cashboxList.find(el => el.id == this.savedCashboxId).name

			else
				return ''
		},
		userDepId() {
			return localStorage.getItem('dep_id')
		}
	},
	methods: {
		...mapActions('departments', ['fetchMyDepartments']),
		...mapActions('references', [
			'getReferenceChildren',
		]),
		getSavedCashboxId() {
			this.savedCashboxId = localStorage.getItem('cash_id')
		},
		/* POPOVER METHODS BEGIN */
		onOpen(itemId) {
			let refName = 'popover' + itemId;
			this.$refs[refName].$emit('open')
		},
		onClose(itemId) {
			let refName = 'popover' + itemId;
			this.$refs[refName].$emit('close')
		},
		async deleteCashbox(itemId) {
			ApiService.delete(`cashbox/delete/${itemId}`)
				.then(res => {
					this.fetchCashboxList()
				})
		},
		/* POPOVER METHODS END */
		closeCashboxModal() {
			this.refInputNotFilled = false;
			this.$refs.updateRefModal.hide();
		},
		fiscalCreate(data) {
			FBoxService.setFiscalIpData(data.item).then(res => {
				this.$vs.notify({
					title: 'Успешно сохранен',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				});
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		openCashboxModal(data) {
			this.refInputNotFilled = false;
			if (data.item) {
				this.modalForAdding = false;
				this.selectedDep = this.myDepartments.find(dep => dep.id === data.item.departmentId)
				this.editingItem.id = data.item.id;
				this.editingItem.name = data.item.name;
				this.editingItem.ipAddress = data.item.ipAddress;
				this.editingItem.comIpAddress = data.item.comIpAddress;
				this.editingItem.isBar = data.item.isBar;
				this.editingItem.isSkyShop = data.item.isSkyShop;
				this.editingItem.withConsultant = data.item.withConsultant;
				this.editingItem.isNew = data.item.isNew;
				this.$refs.updateRefModal.show();
			} else {
				this.selectedDep = null
				this.editingItem = Object.assign({}, itemInitial);
				this.modalForAdding = true;
				this.$refs.updateRefModal.show();
			}
		},
		focusMyElement() {
			this.$refs.childRefNameRef.focus();
		},
		fetchCashboxList(fetchAndUpdate = false) {
			if (this.selectedDepForSearch) {
				ApiService.get(`cashbox/get/by-dep-id/${this.selectedDepForSearch.id}`)
					.then(res => {
						this.cashboxList = res.data
						if (typeof fetchAndUpdate == 'boolean' && fetchAndUpdate && (this.editingItem.id == this.cashboxId)) {
							this.saveCashboxNumber()
						}
						this.closeCashboxModal()
					})
			} else {
				this.$vs.notify({
					title: 'Iltimos, bo\'limni tanlang',
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
			}
		},
		addNewCashbox() {
			if (this.editingItem.name.trim() != '' && this.editingItem.ipAddress.trim() != '' && this.selectedDep) {
				this.refInputNotFilled = false
				this.editingItem.departmentId = this.selectedDep.id
				if (this.modalForAdding)
					ApiService.post(`cashbox/create`, this.editingItem)
						.then(res => {
							this.fetchCashboxList()
						})
				else
					ApiService.put(`cashbox/update/${this.editingItem.id}`, this.editingItem)
						.then(res => {
							this.fetchCashboxList(true)
						})
			} else {
				this.refInputNotFilled = true
			}
		},
		saveCashboxNumber() {
			if (this.cashboxId !== null) {
				TokenService.saveCashBoxId(this.cashboxId)
				TokenService.saveCashBoxIpAddress(this.cashboxList.find(el => el.id == this.cashboxId).ipAddress)
				TokenService.saveCashBoxNumber(this.cashboxList.find(el => el.id == this.cashboxId).name)
				this.getSavedCashboxId()
				this.show = true
				this.errorShow = false
				this.CashBoxNumber()
				if (this.$route.path == '/point-of-sale/beforePos') {
					this.$router.push('/point-of-sale/pos')
				}
				setTimeout(() => {
					this.show = false
				}, 2000);
			} else {
				this.errorShow = true
				setTimeout(() => {
					this.errorShow = false
				}, 2000);
			}
		},
		CashBoxNumber() {
			const cashbox = localStorage.getItem('cash_id')
			this.cashboxId = cashbox
		}
	}
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.btn-frame {
	display: flex;
	justify-content: flex-end;
	margin-top: 10px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	/* display: none; <- Crashes Chrome on hover */
	-webkit-appearance: none;
	margin: 0;
	/* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
	-moz-appearance: textfield;
	/* Firefox */
}

.editBtn {
	font-size: 14px;
	cursor: pointer;
}

.cashbox {
	display: flex;
	justify-content: center;
}

.cashboxnumber {
	font-size: 20px;
	margin-bottom: 4px;
	margin-left: 10px;
}

.success-save {
	display: flex;
	justify-content: center;
	padding: 8px;
}
</style>
